import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const DevButtons = ({ className, startValue, endValue, usageTarget, onSetButtonClick, onRunButtonClick }) => {
  const containerRef = useRef();

  const handleSetButtonClick = () => {
    const { current: container } = containerRef || {};
    const inputs = container?.querySelectorAll('input');
    const newValues = [...inputs].reduce((acc, { value }) => acc.concat(Number(value)), []);

    onSetButtonClick(newValues);
  };

  return (
    <Container ref={containerRef} className={className}>
      <label htmlFor="usage-start-value">
        Last Shown (min):
        <input id="usage-start-value" type="number" name="startValue" defaultValue={startValue} />
      </label>

      <label htmlFor="usage-end-value">
        Weekly Usage (min):
        <input id="usage-end-value" type="number" name="endValue" defaultValue={endValue} />
      </label>
      <button type="button" tabIndex={-1} onClick={handleSetButtonClick}>
        Set Values
      </button>
      <button type="button" tabIndex={-1} onClick={onRunButtonClick}>
        Run Animation
      </button>
      {!usageTarget && (
        <MissingTargetWarning>
          ⚠️ No weekly usage target received. The bar renders without a goal and never celebrates.
        </MissingTargetWarning>
      )}
    </Container>
  );
};

DevButtons.propTypes = {
  className: PropTypes.string,
  startValue: PropTypes.number.isRequired,
  endValue: PropTypes.number.isRequired,
  usageTarget: PropTypes.number,
  onSetButtonClick: PropTypes.func.isRequired,
  onRunButtonClick: PropTypes.func.isRequired,
};

DevButtons.defaultProps = {
  className: '',
  usageTarget: null,
};

export default DevButtons;

const MissingTargetWarning = styled.p`
  flex-basis: 100%;
  margin: 5px 0 0;
  font-size: 13px;
  line-height: 17px;
  color: #8a6d00;
`;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 10px;
  transform: translate(-50%, 0);
  position: absolute;
  top: 0;
  left: 50%;
  background: #fff;
  border: 2px solid gray;

  input {
    width: 60px;
    margin-left: 5px;
  }

  label {
    margin-left: 5px;
    font-size: 14px;
  }

  button {
    margin-left: 10px;

    &:has(+ button) {
      margin-left: auto;
    }
  }
`;
